import React, { Component } from 'react';
import { priceDecimalPrecision } from '../libs/utils/Const';

class CalculatorModal extends Component {

    state = {
        value: ''
    };

    Cancel = () => {

        const { cancel } = this.props;

        cancel();
    };

    Accept = () => {

        const { accept, acceptAmount, newOrderModel, itemIndex } = this.props;
        const value = this.state.value
        const taxRate = newOrderModel?.Items?.[itemIndex]?.TaxeRate ?? 18
        const tax = taxRate / 100
        const newPrice = value / (1 + tax)
        accept(newPrice);
        acceptAmount(value)
    };

    render() {

        const {
            title,
            btnAccept,
            btnCancel,
            size = 'modal-sm',
            btnClose = true,
            placeholder = 'Ingrese monto'
        } = this.props;

        return (

            <div
                className="modal d-block"
                tabIndex="-1"
                role="dialog"
                style={{
                    backgroundColor: 'rgba(0,0,0,0.5)'
                }}
            >

                <div
                    className={`modal-dialog ${size}`}
                    role="document"
                >

                    <div className="modal-content">

                        <div
                            className="modal-header text-white"
                            style={{
                                backgroundColor: '#343a40'
                            }}
                        >

                            <h4 className="modal-title">
                                {title}
                            </h4>

                            {btnClose && (
                                <button
                                    type="button"
                                    className="close"
                                    onClick={this.Cancel}
                                >
                                    <span className="text-white">
                                        &times;
                                    </span>
                                </button>
                            )}

                        </div>

                        <div className="modal-body">

                            <input
                                type="number"
                                min={0}
                                className="form-control text-center"
                                placeholder={placeholder}
                                value={this.state.value}
                                autoFocus
                                onKeyDown={(e) => {

                                    if (
                                        e.key === 'e' ||
                                        e.key === 'E' ||
                                        e.key === '+' ||
                                        e.key === '-'
                                    ) {
                                        e.preventDefault();
                                    }

                                }}
                                onChange={(e) => {

                                    this.setState({
                                        value: e.target.value
                                    });

                                }}
                            />

                        </div>

                        <div className="modal-footer">

                            <button
                                type="button"
                                className="btn botonCorrect"
                                onClick={this.Accept}
                            >
                                {btnAccept}
                            </button>

                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.Cancel}
                            >
                                {btnCancel}
                            </button>

                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default CalculatorModal;